import React, { useEffect, useMemo, useState } from 'react';
import ClayLayout from '@clayui/layout';
import './BusinessExpansionForm.css';
import Stepper from '../../generic-components/stepper/Stepper';
import { getSteps } from '../../utils/commonUtil';
import AlreadyMemberDetail from '../../components/AlreadyMemberDetail/AlreadyMemberDetail';
import OtpVerification from '../../components/OtpVerification/OtpVerification';
import { useAppSelector } from '../../store/hooks';
import ContactDetail from '../../components/ContactDetail/ContactDetail';
import BusinessDetail from '../../components/BusinessDetail/BusinessDetail';
import FinalScreen from '../../components/FinalScreen/FinalScreen';
import MultiStep from '../../components/MultiStep/MultiStep';

const BusinessExpansionForm = () => {
    const [step, setStep] = useState<number>(0);
    const [resStatusCode, setResStatusCode] = useState(0);
    const [resStatusMessage, setResStatusMessage] = useState('');
    const { isFormFilled, isChamberMember } = useAppSelector(
        (state) => state.businessExpansion
    );

    const steps = useMemo(
        () =>
            getSteps({
                isFormFilled: !!isFormFilled,
                isAlreadyMember: !!isChamberMember
            }),
        [isFormFilled, isChamberMember]
    );

    const activeStepKey = steps[step]?.key;

    const stepperItems = steps.map((s) => ({ name: s.subTitle }));

    return (
        <div className="business-expansion-form-wraper" id="expansion-form">
            <ClayLayout.ContentSection className="contact_container">
                <ClayLayout.Row justify="start" className="contact_main">
                    {/* <ClayLayout.Col sm={12} lg={5} className="contact_img p-0">
                    <img
                        src={
                            '/o/business-expansion-form-custom-element/images/banner.webp'
                        }
                    />
                </ClayLayout.Col> */}
                    <ClayLayout.Col sm={12} lg={12} className="contact_form">
                        {step !== 4 && (
                            <>
                                <div className="d-block d-lg-none">
                                    <Stepper
                                        step={step}
                                        setStep={setStep}
                                        items={stepperItems}
                                    />
                                </div>
                                <div className="d-none d-lg-block">
                                    <MultiStep
                                        step={step}
                                        setStep={setStep}
                                        steps={steps}
                                    />
                                </div>
                            </>
                        )}

                        {activeStepKey === 'alreadyMember' && (
                            <div className="personal-info-height">
                                <AlreadyMemberDetail setStep={setStep} />
                            </div>
                        )}
                        {activeStepKey === 'email' && (
                            <OtpVerification setStep={setStep} btnUi="blue" />
                        )}
                        {activeStepKey === 'contact' && (
                            <div className="personal-info-height">
                                <ContactDetail setStep={setStep} />
                            </div>
                        )}
                        {activeStepKey === 'business' && (
                            <div className="personal-info-height">
                                <BusinessDetail
                                    setStep={setStep}
                                    setResStatusMessage={setResStatusMessage}
                                    setResStatusCode={setResStatusCode}
                                />
                            </div>
                        )}
                        {step == 4 && (
                            <div className="personal-info-height">
                                <FinalScreen
                                    setStep={setStep}
                                    resStatusMessage={resStatusMessage}
                                    resStatusCode={resStatusCode}
                                />
                            </div>
                        )}
                    </ClayLayout.Col>
                </ClayLayout.Row>
            </ClayLayout.ContentSection>
        </div>
    );
};

export default BusinessExpansionForm;
